<template>
    <modal @close.stop="closeModal" dialog="modal-lg" class="dark-top saveRuleChanges" :footer="false" :header="false">
         <div slot="body">
            <div class="p-4">
                <div v-if="type === 'rule'">
                    <h2 class="mb-4 text-center bold">Rule Change Confirmation</h2>
                    <p class="text-justify">You are about to modify this rule. This action will have <span class="bold">significant implications</span> as it will affect multiple rule groups applied to various products. Consequently, prices may change, and the conditions for opening or closing sales channels may be adjusted based on occupancy and the new conditions set.</p>
                    <p class="bold mt-4">Do you wish to proceed with these changes and apply the new parameters?</p>
                </div>

                <div v-if="type === 'ruleGroup'">
                    <h2 class="mb-4 text-center bold">Rule Group Change Confirmation</h2>
                    <p class="text-justify">You are about to modify this rule. This action will have <span class="bold">significant implications</span> as it will affect multiple rule groups applied to various products. Consequently, prices may change, and the conditions for opening or closing sales channels may be adjusted based on occupancy and the new conditions set.</p>
                    <p class="bold mt-4">Do you wish to proceed with these changes and apply the new parameters?</p>
                </div>

                <!-- Radio Buttons -->
                <div class="mb-4 pt-3 mt-3 border-top-light">
                    <radio name="resetAll" v-model="optionSelected" :value="true">
                        <span class="darkest">Yes, apply changes.</span>
                    </radio>
                </div>

                <!-- Buttons -->
                <div class="d-flex">
                    <div class="">
                        <button class="btn tertiary" @click="closeModal">Cancel</button>
                    </div>
                    <div class="flexGrow1 text-right">
                        <button class="btn" @click="pressBtn" :disabled="!optionSelected">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from './Modal'
import { mapActions, mapGetters } from 'vuex'

export default {
    data() {
        return {
            optionSelected: false,
            type: ''
        }
    },
    async mounted() {
		this.$nextTick(() => {
			this.eventHub.$on("closeTargetModal", () => {
			    this.closeModal();
			});
		});
	},
    destroyed() {
		this.eventHub.$off('closeTargetModal');
	},
    created() {
        this.type = this.getEditedRuleToSave.type;
    },
    computed: {
        ...mapGetters([
            'getEditedRuleToSave',
        ])
    },
    methods: {
        ...mapActions([
            'closeModal',
            'updateRule',
            'updateRuleGroup',
            'clearEditedRuleToSave',
            'startFullScreenLoading',
            'stopFullScreenLoading'
        ]),
        async pressBtn() {
            const { rule } = this.getEditedRuleToSave;
            const isRule = (this.type === 'rule');
            
            this.$toasted.info('Saving', { duration: 2000 });
            this.startFullScreenLoading();

            let suc;

            if (isRule) {
                suc = await this.updateRule(rule);
            } else {
                suc = await this.updateRuleGroup(rule);
            }

            if (suc) {
                this.$toasted.success('Successfully saved', { duration: 2000 });
            } else {
                this.$toasted.error('An error occurred', { duration: 2000 });
            }

            this.finalizeAndRedirect();
            this.closeModal();
            this.clearEditedRuleToSave();
        },
        finalizeAndRedirect() {
            this.$router.push({ name: 'rules' });
            this.stopFullScreenLoading();
        },
    },
    components: {
        Modal
    }
}
</script>

<style lang="scss">
    .saveRuleChanges .modal-lg{
        max-width: 700px;
    }

    .text-justify {
        text-align: justify;
    }
</style>



// WEBPACK FOOTER //
// RuleSaveChanges.vue?42f8bbf5